import React, { useState, useLayoutEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import SiteEmpresa from './site/SiteEmpresa';
import SiteArCondicionado from './site/SiteArCondicionado';
import SitePaineisSolares from './site/SitePaineisSolares';
import SiteContactos from './site/SiteContactos';
import SiteServicos from './site/SiteServicos';
import SiteCTA from './site/SiteCTA';
import SiteFooter from './site/SiteFooter';
import SiteHeader from './site/SiteHeader';
import TermosCondicoes from './site/TermosCondicoes';
import PoliticaPrivacidade from './site/PoliticaPrivacidade';
import GestaoProApp from './GestaoProApp';
import './styles/App.css';

function isGestaoProPath(pathname) {
  return pathname === '/gestaopro' || pathname.startsWith('/gestaopro/');
}

// Página Serviços do site público
function PaginaServicos() {
  return (
    <div className="min-h-screen bg-gestao-background text-slate-800">
      <SiteHeader />
      <main>
        <SiteServicos />
        <SiteCTA />
        <SiteFooter />
      </main>
    </div>
  );
}

/**
 * URLs sem # (BrowserRouter): /gestaopro, /ar-condicionado, etc. Nunca /#/gestaopro.
 *
 * Duas coisas separadas:
 *
 * 1) SITE ELECTRO SALIR (público) – electrosalir.pt e só estas barras:
 *    /  |  /ar-condicionado  |  /paineis-solares  |  /servicos  |  /contactos
 *    (+ termos e política)
 *
 * 2) GESTÃO PRO (interno, empresa) – electrosalir.pt/gestaopro
 *    Login e app; não tem nada a ver com o site.
 *
 * Usamos o pathname real do browser (window) no primeiro render para evitar
 * que o site apareça em /gestaopro quando o Router ainda não está sincronizado.
 */
export default function App() {
  const location = useLocation();
  const [initialPathname] = useState(() =>
    typeof window !== 'undefined' ? window.location.pathname : ''
  );
  const pathname = location.pathname;
  const showGestaoPro =
    isGestaoProPath(pathname) || isGestaoProPath(initialPathname);

  useLayoutEffect(() => {
    if (showGestaoPro && pathname !== '/' && !isGestaoProPath(pathname)) {
      // Router estava em / mas o URL real é /gestaopro: forçar navegação
      window.history.replaceState(null, '', initialPathname + (window.location.search || ''));
    }
  }, [showGestaoPro, pathname, initialPathname]);

  if (showGestaoPro) {
    return <GestaoProApp />;
  }

  return (
    <Routes>
      <Route path="/paineis-solares" element={<SitePaineisSolares />} />
      <Route path="/ar-condicionado" element={<SiteArCondicionado />} />
      <Route path="/servicos" element={<PaginaServicos />} />
      <Route path="/contactos" element={<SiteContactos />} />
      <Route path="/termos-e-condicoes" element={<TermosCondicoes />} />
      <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
      <Route path="/" element={<SiteEmpresa />} />
    </Routes>
  );
}
